import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-opus-four',
  templateUrl: './opus-four.component.html',
  styleUrls: ['./opus-four.component.scss']
})
export class OpusFourComponent {
  constructor(public dialogRef: MatDialogRef<OpusFourComponent>) {}

   close(): void {
    this.dialogRef.close();
  }
}
